import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BaseURL } from "../../BaseURL";

// Date: 17 Feb 2025

// Thunk to fetch articles from the API
export const fetchOldArticle = createAsyncThunk(
  "compareOldArticle/fetchArticle",
  async (
    { versionSlug, tokenMode, selectedHighlight },
    { rejectWithValue }
  ) => {
    try {
      // ACCESS TOKEN
      const accessToken = localStorage.getItem("access_token");
      // CN ACCESS TOKEN
      const cnAccessToken = localStorage.getItem("cn_access_token");

      const versionData = {
        version: versionSlug,
      };
      // Convert the data to query string
      const queryParams = new URLSearchParams(versionData).toString();
      const response = await fetch(
        `${BaseURL}/${tokenMode}/posts?${queryParams}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${
              tokenMode === "personal" ? accessToken : cnAccessToken
            }`,
          },
        }
      );
      if (!response.ok) {
        throw new Error(`Error: ${response.status} ${response.statusText}`);
      }
      const data = await response.json();
      //   return data; // Assuming API returns { oldArticle: "...", newArticle: "..." }
      if (response.ok) {
        const updatedData = await data.data.map((item) => {
          return {
            ...item,
            posts: item.posts.map((post) => ({
              ...post,
              name: item.name,
            })),
          };
        });
        // console.log("myAllPoost", updatedData)
        const myAllPosts = await updatedData.flatMap(
          (category) => category.posts
        );
        const newCompArticle = await myAllPosts.filter(
          (post) => post.slug === selectedHighlight
        );
        if (newCompArticle.length > 0) {
          const mainData = { oldArticle: newCompArticle[0].body || "" };
          // // Date: 19 Feb 2025
          // if (mainData === "") {
          //   rejectWithValue(
          //     `"${selectedHighlight}" Article not avialable in the selected version`
          //   );
          // }
          return mainData;
        } else {
          return rejectWithValue(
            `"${selectedHighlight}" Article not avialable in the selected version`
          );
        }
      }
    } catch (error) {
      if (error.message === "Failed to fetch") {
        return rejectWithValue("Can't connect to the network");
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const CompareOldArticleSlice = createSlice({
  name: "compareOldArticle",
  initialState: {
    oldArticle: "",
    isLoadingOldArticle: false,
    errorOldArticle: null,
  },
  reducers: {
    oldEmptyCompArticle: (state, action) => {
      state.oldArticle = "";
    },
    defaultStateOldArticleSliceFunc: (state, action) => {
      state.oldArticle = "";
      state.isLoadingOldArticle = false;
      state.errorOldArticle = null;
    },
    cleanedOldArticle: (state, action) => {
      state.oldArticle = action.payload;
    },
  }, // No additional reducers needed for now
  extraReducers: (builder) => {
    builder
      .addCase(fetchOldArticle.pending, (state) => {
        state.isLoadingOldArticle = true;
        state.errorOldArticle = null;
      })
      .addCase(fetchOldArticle.fulfilled, (state, action) => {
        state.isLoadingOldArticle = false;
        state.oldArticle = action.payload.oldArticle;
        // state.newArticle = action.payload.newArticle;
      })
      .addCase(fetchOldArticle.rejected, (state, action) => {
        state.isLoadingOldArticle = false;
        state.errorOldArticle = action.payload;
      });
  },
});
export const {
  oldEmptyCompArticle,
  cleanedOldArticle,
  defaultStateOldArticleSliceFunc,
} = CompareOldArticleSlice.actions;
export default CompareOldArticleSlice.reducer;
